/** Connexion Microsoft OAuth — Outlook.com / Microsoft 365. */
export const MAIL_MICROSOFT_OAUTH_ENABLED = true;
